/**
 * Community listing categories and conditions (match backend CommunityListing model).
 */
export const LISTING_CATEGORIES = [
  { value: 'hunting_clothes', label: 'Hunting clothes' },
  { value: 'treestands_blinds', label: 'Treestands & blinds' },
  { value: 'rvs_campers_trailers', label: 'RVs, campers & trailers' },
  { value: 'camp_gear', label: 'Camp gear' },
  { value: 'fire_campfire', label: 'Fire & campfire' },
  { value: 'atvs_utvs', label: 'ATVs & UTVs' },
  { value: 'hunting_gear', label: 'Hunting gear (bows, ammo, etc.)' },
  { value: 'other', label: 'Other' },
];

export const LISTING_CONDITIONS = [
  { value: 'new', label: 'New' },
  { value: 'like_new', label: 'Like new' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
];

export const AUTO_REMOVE_DAYS = 60;
export const MAX_PHOTOS = 5;
